<template>
  <div class="boxshadow-conatiner" ref="boxShadowList">

    <ul class="boxshadow-list">
      <li
        class="boxshadow-color-scan verticallyCenter"
        :class="activeBoxShadow === index ? 'active' : ''"
        v-for="(boxShadow, index) in boxShadowHVal"
        :key="'box-' + index"
        @click.stop="editBoxShadow($event, index)"
      >
        <span class="color-scan el-color-picker__color is-alpha">
          <span :style="{background: (boxShadowColorVal[index] && boxShadowColorVal[index].indexOf('inset')>-1)?boxShadowColorVal[index].replace('inset',''): boxShadowColorVal[index]}"></span>
        </span>
        <span class="color-text1 ml26 mr8">
          {{
            boxShadowColorVal[index] && boxShadowColorVal[index].indexOf("inset")>-1?'内阴影':'外阴影'
          }}</span>
        <span class="color-text w100_90 overflowHid1">{{
          `${boxShadow}px ${boxShadowVVal[index]}px ${boxShadowBlurVal[index]}px ${boxShadowSpreadVal[index]}px`
        }}</span>
        <span class="icon-portal-delete delete-boxshadow right-handle-icon" @click.stop="delBoxShadow(index)"></span>
      </li>
    </ul>
    <div
      class="boxshadow-wrap-container"
      v-show="typeof activeBoxShadow !== 'undefined'"
      @click.stop.self="activeBoxShadow = undefined"
    >
      <div
        v-show="typeof activeBoxShadow !== 'undefined'"
        class="boxshadow-wrap"
        ref="boxshadowSetBox"
        :style="boxStyle"
      >
        <SliderSelect :options="boxShadowTypeList" :value.sync="activeBoxShadowType" :useToolTip="true"></SliderSelect>
        <div class="slider-input-container mt16">
          <span class="fs12 w30" style="height: 17px">x轴</span>
          <slider-and-input class="ml8 middle-dot" :value.sync="activeBoxShadowH" :sliderMax="500" :sliderMin="-500" suffix="px" />
        </div>
        <div class="slider-input-container mt16">
          <span class="fs12 w30" style="height: 17px">y轴</span>
          <slider-and-input class="ml8 middle-dot" :value.sync="activeBoxShadowV" :sliderMax="500" :sliderMin="-500" suffix="px" />
        </div>
        <div class="slider-input-container mt16">
          <span class="fs12 w30" style="height: 17px">模糊</span>
          <slider-and-input class="ml8" :value.sync="activeBoxShadowBlur" :sliderMax="100" suffix="px" />
        </div>
        <div class="slider-input-container mt16">
          <span class="fs12 w30" style="height: 17px">扩展</span>
          <slider-and-input class="ml8 middle-dot" :value.sync="activeBoxShadowSpread" :sliderMax="500" :sliderMin="-500" suffix="px" />
        </div>
        <div class="slider-input-container mt16">
          <span class="fs12 mr8 w24" style="height: 17px">颜色</span>
          <div class="color-picker-container w100_40">
            <el-color-picker
              color-format="rgb"
              v-model="activeBoxShadowColor"
              :show-alpha="true"
              @active-change="activeChangeColor"
            ></el-color-picker>
            <span class="color-text1 mr8">{{activeBoxShadowType==='inset'?'内阴影':'外阴影'}}</span>
            <span class="color-text">{{ activeBoxShadowColor }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { historyIgnoreWrap } from "utils/revork"
import SliderSelect from "modules/components/sliderSelect.vue"
export default {
  name: "boxShadow",
  components: {
    SliderSelect
  },
  props: {
    isOnlyScan: {
      default: false,
      required: false
    },
    boxShadowColor: {
      type: null, // 颜色有字符串和null的情况
      required: true
    },
    boxShadowH: {
      type: [Array, String, Number],
      required: true
    },
    boxShadowV: {
      type: [Array, String, Number],
      required: true
    },
    boxShadowBlur: {
      type: [Array, String, Number],
      required: true
    },
    boxShadowSpread: {
      type: [Array, String, Number],
      required: true
    }
  },
  data() {
    return {
      this1: this,
      tooltipDelay: 1000,
      activeBoxShadow: undefined,
      boxStyle: {},
      itemWrap: undefined,
      boxShadowTypeList:[
        {
          value: '',
          label:'外阴影'
        },
        {
          value:'inset',
          label:'内阴影'
        }
      ]
    }
  },
  computed: {
    boxShadowColorVal: {
      get() {
        let boxShadowColor = this.boxShadowColor || ["#fff"]
        if(boxShadowColor.indexOf("inset") >-1){
          boxShadowColor = boxShadowColor.replace("inset","")
        }
        if (Array.isArray(boxShadowColor)) {
          return boxShadowColor
        } else {
          historyIgnoreWrap(() => {
            this.boxShadowColorVal = [boxShadowColor]
          })()
          return [boxShadowColor]
        }
      },
      set(val) {
        this.$emit("update:boxShadowColor", val)
      }
    },
    boxShadowHVal: {
      get() {
        let boxShadowH = this.boxShadowH || [0]
        return Array.isArray(boxShadowH) ? boxShadowH : [boxShadowH]
      },
      set(val) {
        if (
          typeof val !== typeof this.boxShadowH ||
          val.length !== this.boxShadowHVal.length ||
          val.some((item, index) => item !== this.boxShadowHVal[index])
        ) {
          this.$emit("update:boxShadowH", val)
        }
      }
    },
    boxShadowVVal: {
      get() {
        let boxShadowV = this.boxShadowV || [0]
        if (Array.isArray(boxShadowV)) {
          return boxShadowV
        } else {
          this.boxShadowVVal = [boxShadowV]
        }
      },
      set(val) {
        if (
          typeof val !== typeof this.boxShadowV ||
          val.length !== this.boxShadowVVal.length ||
          val.some((item, index) => item !== this.boxShadowVVal[index])
        ) {
          this.$emit("update:boxShadowV", val)
        }
      }
    },
    boxShadowBlurVal: {
      get() {
        let boxShadowBlur = this.boxShadowBlur || [0]
        if (Array.isArray(boxShadowBlur)) {
          return boxShadowBlur
        } else {
          this.boxShadowBlurVal = [boxShadowBlur]
        }
      },
      set(val) {
        if (
          typeof val !== typeof this.boxShadowBlur ||
          val.length !== this.boxShadowBlurVal.length ||
          val.some((item, index) => item !== this.boxShadowBlurVal[index])
        ) {
          this.$emit("update:boxShadowBlur", val)
        }
      }
    },
    boxShadowSpreadVal: {
      get() {
        let boxShadowSpread = this.boxShadowSpread || [0]
        if (Array.isArray(boxShadowSpread)) {
          return boxShadowSpread
        } else {
          this.boxShadowSpreadVal = [boxShadowSpread]
        }
      },
      set(val) {
        if (
          typeof val !== typeof this.boxShadowSpread ||
          val.length !== this.boxShadowSpreadVal.length ||
          val.some((item, index) => item !== this.boxShadowSpreadVal[index])
        ) {
          this.$emit("update:boxShadowSpread", val)
        }
      }
    },
    activeBoxShadowType:{
       get(){
         let color = this.boxShadowColorVal[this.activeBoxShadow]
         if(color?.indexOf("inset")>-1){
           return "inset"
         }
         return ""
       },
       set(val){
          let newActiveColor
          if(val){
            newActiveColor = `${this.activeBoxShadowColor} ${val}`
          }else{
            newActiveColor = this.activeBoxShadowColor.indexOf("inset")>-1? this.activeBoxShadowColor.replace("inset","") : this.activeBoxShadowColor
          }
         let newVal = JSON.parse(JSON.stringify(this.boxShadowColorVal))
         newVal[this.activeBoxShadow] = newActiveColor
         this.$set(this, "boxShadowColorVal", newVal)
       }
    },
    activeBoxShadowColor: {
      get() {
        let color = this.boxShadowColorVal[this.activeBoxShadow]
        if(color?.indexOf("inset")> -1){
          return color.replace("inset", "")
        }
        return color
      },
      set(val) {
        let newVal = JSON.parse(JSON.stringify(this.boxShadowColorVal))
        newVal[this.activeBoxShadow] = val
        if(this.activeBoxShadowType === "inset"){
          newVal[this.activeBoxShadow] = `${val} inset`
        }
        this.$set(this, "boxShadowColorVal", newVal)
      }
    },
    activeBoxShadowH: {
      get() {
        return this.boxShadowHVal[this.activeBoxShadow]
      },
      set(val) {
        let newVal = JSON.parse(JSON.stringify(this.boxShadowHVal))
        newVal[this.activeBoxShadow] = val
        this.$set(this, "boxShadowHVal", newVal)
      }
    },
    activeBoxShadowV: {
      get() {
        return this.boxShadowVVal[this.activeBoxShadow]
      },
      set(val) {
        let newVal = JSON.parse(JSON.stringify(this.boxShadowVVal))
        newVal[this.activeBoxShadow] = val
        this.$set(this, "boxShadowVVal", newVal)
      }
    },
    activeBoxShadowBlur: {
      get() {
        return this.boxShadowBlurVal[this.activeBoxShadow]
      },
      set(val) {
        let newVal = JSON.parse(JSON.stringify(this.boxShadowBlurVal))
        newVal[this.activeBoxShadow] = val
        this.$set(this, "boxShadowBlurVal", newVal)
      }
    },
    activeBoxShadowSpread: {
      get() {
        return this.boxShadowSpreadVal[this.activeBoxShadow]
      },
      set(val) {
        let newVal = JSON.parse(JSON.stringify(this.boxShadowSpreadVal))
        newVal[this.activeBoxShadow] = val
        this.$set(this, "boxShadowSpreadVal", newVal)
      }
    },
  },
  mounted() {
    this.closeColorSelectStatu()
  },
  beforeDestroy() {
    document.getElementsByClassName("toolbar")[0].removeEventListener("click", this.removeActive)
  },
  methods: {
    changeColorType() {},
    delBoxShadow(index) {
      this.boxShadowHVal.splice(index, 1)
      this.boxShadowVVal.splice(index, 1)
      this.boxShadowBlurVal.splice(index, 1)
      this.boxShadowSpreadVal.splice(index, 1)
      this.boxShadowColorVal.splice(index, 1)
      this.$forceUpdate()
      document.getElementsByClassName("boxshadow-wrap")[0].style.display = "none"
    },
    editBoxShadow(event, index) {
      if (this.isOnlyScan) {
        return
      }
      this.activeBoxShadow = index
      let bottom = event.target.getBoundingClientRect().bottom
      let top = event.target.getBoundingClientRect().top
      let boxTop = this.$refs.boxShadowList.getBoundingClientRect().top
      this.findParentNode(this.$refs.boxShadowList, "el-collapse-item__wrap", "itemWrap")
      if (this.itemWrap) {
        this.itemWrap.classList.add("active")
      }
      this.$nextTick(() => {
        let boxH = this.$refs.boxshadowSetBox.clientHeight
        let windowH = document.documentElement.clientHeight
        if (boxH + bottom > windowH - 30) {
          // 下拉框向上显示 , 90是顶部操作栏 + 工具栏顶部面包屑的距离
          this.boxStyle = {
            top: top - boxH - 10 - 90 + "px",
            bottom: "auto"
          }
        } else {
          this.boxStyle = {
            bottom: "auto",
            top: bottom + 10 - 90 + "px"
          }
        }
        document.getElementsByClassName("boxshadow-wrap")[0].style.display = "block"
      })
    },
    findParentNode(ele, className, target) {
      if (!ele.parentNode) return null
      if (ele.parentNode.className?.includes(className)) {
        this[target] = ele.parentNode
        return ele.parentNode
      }
      this.findParentNode(ele.parentNode, className, target)
    },
    closeColorSelectStatu() {
      let _this = this
      let ele = this.$refs.boxShadowList
      let toolbar = document.getElementsByClassName("toolbar")
      if (toolbar.length === 0) {
        return
      }
      document.getElementsByClassName("toolbar")[0].addEventListener("click", this.removeActive)
    },
    getFocus(event) {
      event.currentTarget.select()
    },
    activeChangeColor(val) {
      this.activeBoxShadowColor = val
    },
    removeActive(e) {
      const ele = this.$refs.boxShadowList
      if (ele && ele.contains(e.target)) {
        return
      }
      this.activeBoxShadow = undefined
      if (this.itemWrap && this.itemWrap.classList) {
        this.itemWrap.classList.remove("active")
      }
    }
  }
}
</script>

<style scoped lang="scss">
.boxshadow-conatiner {
  position: relative;
}
.boxshadow-wrap-container {
  position: fixed;
  width: 260px;
  top: 90px;
  bottom: 0;
  right: 0;
  z-index: 101;
  background-color: var(--dialogShade);
}
.boxshadow-wrap {
  position: absolute;
  left: 12px;
  padding: 18px;
  width: 252px;
  background: var(--leftMenuBgColor);
  border: 1px solid var(--sliderBackGround);
  box-sizing: border-box;
  box-shadow: 0px 6px 16px -8px rgba(0, 0, 0, 0.08), 0px 9px 28px rgba(0, 0, 0, 0.05),
    0px 12px 48px 16px rgba(0, 0, 0, 0.03);
  border-radius: 4px;
  z-index: 9999;
}
.w100_40 {
  width: calc(100% - 36px);
}
.color-picker-container:hover .bind-icon {
  display: inline-block;
}
.color-picker-container .bind-icon {
  display: none;
  position: absolute;
  right: 6px;
  top: 4px;
  width: 24px;
  height: 24px;
  line-height: 24px;
  border-radius: 3px;
  text-align: center;
  font-size: 24px;
  cursor: pointer;
  overflow: hidden;
}
.color-picker-container .bind-icon:visited,
.color-picker-container .bind-icon:active {
  background-color: transparent;
}
.color-picker-container .color-text {
  width: calc(100% - 40px);
}
::v-deep .el-color-picker__mask {
  width: 20px;
  height: 20px;
  background-color: transparent;
}
::v-deep .el-color-picker.is-disabled .el-color-picker__color {
  border-radius: 50%;
  overflow: hidden;
}
::v-deep .color-picker-container .color-text1{
  display: inline-block;
  vertical-align: top;
  line-height: 20px;
  position: absolute;
  top: 6px;
  left: 30px;
  width: 46px;
}
::v-deep .color-picker-container .color-text{
  width: calc(100% - 80px);
  left:70px;
}
.boxshadow-list {
  /*padding: 8px;*/
  box-sizing: border-box;
  border-radius: 4px;
  margin-top: 8px;
  position: relative;
  .ml26{
    margin-left: 26px;
  }
  > li:not(:last-child) {
    margin-bottom: 8px;
  }
  > li {
    background: var(--inputBg);
    position: relative;
    height: 32px;
    border-radius: 4px;
    padding: 6px;
    /* background: #ffffff; */
    /*border: 1px solid var(--borderColorFour);
    background-color: var(--dialogBgColor*/
    &:hover {
      /*background-color: var(--rulerBgColor);*/
      .right-handle-icon {
        display: inline-block;
      }
    }
    &.active {
      border-color: var(--themeColor);
      /*background-color: var(--dialogBgColor);*/
    }
  }
  .color-scan {
    display: inline-block;
    border-radius: 4px;
    width: 20px;
    height: 20px;
    margin: 0 6px;
    span {
      display: inline-block;
      width: 100%;
      height: 100%;
    }
  }
  .delete-boxshadow {
    font-size: 14px;
  }
}
::v-deep .middle-dot .el-slider{
  position: relative;
}
::v-deep .middle-dot .el-slider:before{
   display: inline-block;
   position: absolute;
   left: 50%;
   top:50%;
   width: 4px;
   height: 4px;
   margin-left: -2px;
   margin-top: -2px;
   background-color: var(--fourthTextColor);
   z-index: 1;
}
.w100_90{
  width: calc(100% - 90px);
}
</style>
